<template>
    <div class="other-connect">
        <div v-if="!showFinal" class="connect-grid instruction-only">
            <aside class="panel pad data-card">
                <div>
                    <h3>Инструкция по API</h3>
                    <p>
                        Передайте инструкцию разработчику и вернитесь к заполнению, когда данные будут
                        готовы.
                    </p>
                </div>

                <div class="field-stack">
                    <div class="empty-form">
                        Выполните инструкцию и переходите дальше.
                        <a
                            class="instruction-link"
                            :href="instructionUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Открыть инструкцию
                        </a>
                    </div>
                </div>
            </aside>
        </div>

        <div v-else class="final-stage">
            <div class="final-card">
                <p class="final-lead">
                    Если нужно что-то уточнить или вы изучили инструкцию и готовы оставить заявку,
                    напишите в техподдержку Data Heroes:
                    <a
                        href="https://t.me/dataheroes_bot"
                        target="_blank"
                        rel="noopener noreferrer"
                    ><strong>Telegram</strong></a>
                    или
                    <a
                        href="https://max.ru/id7707452371_bot"
                        target="_blank"
                        rel="noopener noreferrer"
                    ><strong>MAX</strong></a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { getCurrentInstance, inject, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import useRouter from '@/hooks/useRouter'
import { useProject } from '@/hooks/useProject'

const INSTRUCTION_URL =
    'https://docs.google.com/document/d/1hJIbZNC_HlfQSxq4McPwjFSVAEUtDZnvU1QIUpgHUvs/edit#heading=h.aq3gurnmlgy6'

export default {
    name: 'OtherConnector',
    setup() {
        const root = getCurrentInstance().proxy
        const store = root.$store
        const { project } = useProject()
        const router = useRouter()
        const wizardNav = inject('onboardingWizardNav', null)
        const otherCrmFinal = inject('onboardingOtherCrmFinal', null)
        const showFinal = ref(false)

        const goBackToCrm = () => {
            otherCrmFinal?.set?.(false)
            root.$parent.$emit('goBackToCrm')
        }

        const goBackToInstruction = () => {
            showFinal.value = false
        }

        const goToFinal = () => {
            showFinal.value = true
        }

        const finishOnboarding = async () => {
            const projectId = project.value?.id
            if (projectId) {
                localStorage.removeItem(projectId + '-onboardingSelectedCrm')
            }
            sessionStorage.removeItem('currentAddingConnector')
            store.commit('project/updateCurrentAddingConnector', null)

            try {
                if (projectId && project.value) {
                    project.value.isOnBoardingActive = false
                    await store.dispatch('project/updateProjectSettings', {
                        projectId,
                        settings: project.value,
                    })
                }
            } catch (e) {
                // ignore: всё равно выходим на список проектов
            }

            router.router.push('/projects')
        }

        const syncWizardNav = () => {
            if (!wizardNav) return
            if (showFinal.value) {
                otherCrmFinal?.set?.(true)
                wizardNav.set({
                    canBack: true,
                    canNext: true,
                    nextLoading: false,
                    nextLabel: 'Закрыть',
                    onBack: goBackToInstruction,
                    onNext: finishOnboarding,
                })
                return
            }
            otherCrmFinal?.set?.(false)
            wizardNav.set({
                canBack: true,
                canNext: true,
                nextLoading: false,
                nextLabel: 'Далее',
                onBack: goBackToCrm,
                onNext: goToFinal,
            })
        }

        watch(showFinal, syncWizardNav, { immediate: true })

        onMounted(() => {
            syncWizardNav()
        })

        onBeforeUnmount(() => {
            otherCrmFinal?.set?.(false)
            wizardNav?.reset?.()
        })

        return {
            instructionUrl: INSTRUCTION_URL,
            showFinal,
        }
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.other-connect
    width: 100%
    max-width: 100%
    min-width: 0
    margin-top: 0 !important
    box-sizing: border-box

.connect-grid
    display: grid
    grid-template-columns: minmax(0, 1fr) minmax(0, 0.8fr)
    gap: 18px
    align-items: start
    width: 100%
    max-width: 100%
    min-width: 0
    box-sizing: border-box
    &.instruction-only
        grid-template-columns: minmax(0, 520px)
        justify-content: center

.panel
    width: 100%
    max-width: 100%
    min-width: 0
    border: 1px solid $border-new
    border-radius: 22px
    background: #fff
    box-shadow: 0 12px 32px rgba(26, 26, 46, 0.06)
    box-sizing: border-box
    &.pad
        padding: 24px

.data-card
    display: grid
    grid-template-rows: auto auto auto
    gap: 16px
    align-content: start

    h3
        font-size: 18px
        margin: 0
        letter-spacing: -0.04em
        font-weight: 800
        color: $dark-new

    p
        margin: 8px 0 0
        color: $muted-new
        font-size: 13px
        line-height: 1.55

.field-stack
    display: grid
    gap: 14px
    align-content: start

.empty-form
    border: 1px dashed rgba(82, 90, 213, 0.3)
    background: #F8FAFF
    border-radius: 16px
    padding: 16px
    color: #596174
    font-size: 13px
    line-height: 1.55

.instruction-link
    margin-top: 12px
    height: 38px
    border-radius: 10px
    background: $main-new
    color: #fff !important
    display: inline-flex
    align-items: center
    justify-content: center
    padding: 0 14px
    font-size: 12px
    font-weight: 900
    text-decoration: none !important
    box-shadow: 0 8px 18px rgba(82, 90, 213, 0.18)

.final-stage
    width: 100%
    display: flex
    align-items: center
    justify-content: center

.final-card
    width: 100%
    max-width: 720px
    border-radius: 28px
    background: #fff
    border: 1px solid $border-new
    box-shadow: 0 16px 42px rgba(26, 26, 46, 0.08)
    padding: 40px
    display: grid
    justify-items: center
    text-align: center
    gap: 14px

.final-lead
    margin: 0
    color: $muted-new
    font-size: 15px
    line-height: 1.6
    max-width: 560px

    a
        color: #2F8CFF
        font-weight: 900
        text-decoration: underline
        text-decoration-thickness: 1px
        text-underline-offset: 3px
        &:hover
            color: $main-new

@media (max-width: 700px)
    .connect-grid
        grid-template-columns: 1fr
    .connect-grid.instruction-only
        grid-template-columns: 1fr
    .panel.pad
        padding: 16px
        border-radius: 18px
    .final-card
        padding: 28px 20px
        border-radius: 20px
</style>
